import React from 'react'

const Lookup = ({
  size,
  style,
  primaryColor,
  secondaryColor,
  title = 'icon/lookup',
  ...props
}) => (
  <svg height='40' width='40' viewBox='0 0 40 40' style={style} {...props}>
    <g fill={primaryColor} fillRule='nonzero'>
      <path d='M30 17.5C30 10.607 24.392 5 17.5 5 10.607 5 5 10.607 5 17.5 5 24.392 10.607 30 17.5 30 24.392 30 30 24.392 30 17.5zM17.5 29C11.159 29 6 23.841 6 17.5S11.159 6 17.5 6 29 11.159 29 17.5 23.841 29 17.5 29z' />
      <path d='M34.767 32.647l-6.722-6.723a13.592 13.592 0 0 1-2.12 2.121l6.721 6.723a.5.5 0 0 0 .708 0l1.414-1.415a.5.5 0 0 0 0-.707z' />
    </g>
  </svg>
)

export default Lookup
